/** Format minute counts for visit wait/consult timing chips. */
export function formatDurationMinutes(mins) {
  if (mins == null || !Number.isFinite(Number(mins))) return null;
  const n = Math.max(0, Math.round(Number(mins)));
  if (n < 60) return `${n}m`;
  const h = Math.floor(n / 60);
  const m = n % 60;
  return m ? `${h}h ${m}m` : `${h}h`;
}
